import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../i18n/I18nUtils';
import CollapseCard from '../../shared/components/CollapseCard';
import ActiveLabel from '../../shared/components/ActiveLabel';

export default class MachineInfoCard extends React.Component {

    render() {
        const {
            name,
            model,
            brand,
            notes,
            machine_state,
            document_schema,
        } = this.props.machine;

        let title = ( name ? name + ' - ' : '' );
        title += brand + ' ' + model;
        title += ( document_schema ? ' - ' + document_schema.name : '' );

        return (
            <CollapseCard
                title={title}
                collapsed={false}
            >
                <div className="info-card-content">
                    <div>
                        <b>{I18nUtils.tr('TR_ESTADO')}: </b>
                        <span>{machine_state ? <ActiveLabel state={machine_state}/> : '-'}</span>
                    </div>
                    <div>
                        <b>{I18nUtils.tr('TR_DESCRIPCION')}: </b>
                        <span>{notes ? notes : '---'}</span>
                    </div>
                </div>
            </CollapseCard>
        );
    }
}

MachineInfoCard.propTypes = {
    machine: PropTypes.shape({
        document_schema_id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        brand: PropTypes.string.isRequired,
        model: PropTypes.string.isRequired,
        state: PropTypes.number.isRequired,
    }),
};

MachineInfoCard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/machines/components/MachineInfoCard.js